/**
 * Shared offsets for bottom-anchored UI that needs to clear the
 * DevEnvironmentBanner (`position: sticky; bottom: 0`, roughly 40px
 * tall when stuck to the viewport during scroll). Any future
 * bottom-floating affordance (drawers, snackbars, toasts) should
 * consume these so they all sit above the banner consistently.
 */
export const BOTTOM_CHROME_RESERVE_PX = 40
export const BOTTOM_CHROME_Z_INDEX = 1300

/**
 * Height of the Help/feedback FAB. Bottom-right toasts stack directly
 * above it, so both the FAB and the toast container derive their bottom
 * offset from this single value - keep them aligned by importing it
 * rather than re-hardcoding 48 in either place.
 */
export const FAB_HEIGHT_PX = 48
